// src/Header.js
import React from "react";
import { NavLink, useLocation } from "react-router-dom";

export default function Header() {
  const location = useLocation();

  return (
    <nav className="header">
      <ul className="nav-list">
        <li>
          <NavLink
            to="/home"
            end
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            Home
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/gallery"
            className={() =>
              location.pathname === "/gallery" ||
              location.pathname.startsWith("/art")
                ? "active"
                : ""
            }
          >
            Gallery
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/doodle"
            className={() =>
              location.pathname === "/doodle" ? "active" : ""
            }
          >
            Doodle
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/blog"
            className={() =>
              location.pathname === "/blog" ||
              location.pathname.startsWith("/blog")
                ? "active"
                : ""
            }
          >
            Blog
          </NavLink>
        </li>

        <li>
          <a
            href="https://shop.minminmarket.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Shop
          </a>
        </li>

        <li>
          <NavLink
            to="/contact"
            className={() => (location.pathname === "/contact" ? "active" : "")}
          >
            Contact
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}
